import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import {capitalize, getValidatedLimit} from "../../components/Utility";
import Form from "../../components/common/form/Form";
import {Status} from "../../enums/enums";
import {expenseProductSchema} from "../../schema/expeneProductSchema";
import {getFormData} from "../../models/expenseProductModel";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchTagList} from "../../store/list-slice";
import {fetchExpenseProductById, updateExpenseProducts} from "../../store/expense-product-slice";

const ExpenseProductEdit = () => {
    const params = useParams();
    const expenseType = params.expenseType;
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.expenseProduct);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items:expenseProducts,
        updateStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.expenseProduct);

    const {
        items,
    } = useSelector(state => state.menu.transactionType);

    const expenseTypeId = items.find(
        (item) => item.name.toLowerCase() === expenseType.toLowerCase()
    )?._id;

    const userRole = useSelector((state) => state.auth.selectedRole);
    const list = useSelector(state => state.list);

    useEffect(() => {
        if (updateStatus === "success") {
            navigator(`../../?page=${currentPage}&limit=${limit}`);
        }
    }, [updateStatus, dispatch, navigator, currentPage, limit]);

    useEffect(() => {
        dispatch(fetchExpenseProductById(
            {
                ...userRole,
                id: params.productId
            }
        ));
    }, [dispatch, params.productId, userRole]);

    useEffect(() => {
        dispatch(fetchTagList(userRole));
    }, [dispatch, userRole]);

    const product = expenseProducts.find(item => item.id === params.productId);

    const formSubmitHandler = (data) => {
        const updatedData = {
            ttid: expenseTypeId,
            ...data
        }

        dispatch(updateExpenseProducts(
            {
                ...userRole,
                data: updatedData,
                id: params.productId,
            }
        ));
    };

    const formCancelHandler = () => {
        navigator(`../../?page=${currentPage}&limit=${limit}`);
    }

    const schema = expenseProductSchema({list, Status});
    const initialData = getFormData(product);

    return (
        <>
            <SubHeader title={`Update ${capitalize(params.expenseType)} Product`}>
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form onFormSubmit={formSubmitHandler}
                                  onFormCancel={formCancelHandler}
                                  schema={schema}
                                  inline={false}
                                  initialData={initialData}
                                  status={updateStatus}
                                  error={error}/>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExpenseProductEdit